var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "flex-column form-fields-opportunities" },
    [
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "name",
            label: _vm.$t.__(
              "thirds.thirdscomponents.FormFieldsOpportunity.opportunity_name"
            )
          }
        },
        [
          _c("el-input", {
            ref: "name",
            attrs: {
              autocomplete: "off",
              "data-bot": "opp-overview__main--name"
            },
            model: {
              value: _vm.name,
              callback: function($$v) {
                _vm.name = $$v
              },
              expression: "name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          staticClass: "prelative wp-5",
          attrs: {
            prop: "amount",
            label: _vm.$t.__("common.labels.potential_amount")
          }
        },
        [
          _c("el-input", {
            staticClass: "aleft",
            attrs: { type: "number", "data-bot": "opp-overview__main--amount" },
            model: {
              value: _vm.amount,
              callback: function($$v) {
                _vm.amount = $$v
              },
              expression: "amount"
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass:
                "fc-unselectable pabsolute fs-5 el-input-icons__percentage"
            },
            [_vm._v(_vm._s(_vm.currency))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "deadline",
            label: _vm.$t.__("common.labels.expected_close_date")
          }
        },
        [
          _c("date-input", {
            staticClass: "wp-5",
            attrs: {
              mode: "edit",
              "data-bot": "opp-overview__main--deadline",
              type: "date",
              defaultValue: _vm.currentDate,
              format: "dmy",
              options: _vm.dateOptions
            },
            model: {
              value: _vm.deadline,
              callback: function($$v) {
                _vm.deadline = $$v
              },
              expression: "deadline"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "sourceRate",
            label: _vm.$t.__(
              "thirds.thirdscomponents.FormFieldsOpportunity.source_category"
            )
          }
        },
        [
          _c(
            "el-select",
            {
              ref: "sourceRate",
              staticClass: "wp-10",
              attrs: {
                placeholder: _vm.$t.__(
                  "thirds.thirdscomponents.FormFieldsOpportunity.select_source_category"
                ),
                "data-bot": "opp-overview__main--source-rate"
              },
              model: {
                value: _vm.sourceRate,
                callback: function($$v) {
                  _vm.sourceRate = $$v
                },
                expression: "sourceRate"
              }
            },
            _vm._l(_vm.listings.sourceRateList, function(option) {
              return _c("el-option", {
                key: option.value,
                ref: "sourceRate",
                refInFor: true,
                attrs: {
                  "data-bot": "opp-overview__main--source-rate-list",
                  value: option,
                  disabled: option.disabled,
                  label: option.label
                }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasSourceRate
        ? _c(
            "el-form-item",
            {
              attrs: {
                prop: "source",
                label: _vm.$t.__("common.labels.source")
              }
            },
            [
              _c(
                "el-select",
                {
                  ref: "source",
                  staticClass: "wp-10",
                  attrs: {
                    placeholder: _vm.$t.__(
                      "thirds.thirdscomponents.FormFieldsOpportunity.select_source"
                    ),
                    "data-bot": "opp-overview__main--source"
                  },
                  model: {
                    value: _vm.source,
                    callback: function($$v) {
                      _vm.source = $$v
                    },
                    expression: "source"
                  }
                },
                _vm._l(_vm.listings.sourceList, function(option) {
                  return _c("el-option", {
                    key: option.value,
                    ref: "source",
                    refInFor: true,
                    attrs: {
                      "data-bot": "opp-overview__main--source-list",
                      value: option,
                      label: option.label
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("h4", { staticClass: "gray-60 m-0 mt-5 mb-2" }, [
        _vm._v(
          _vm._s(_vm._f("upperCase")(_vm.$l10n.__("Informations pipeline")))
        )
      ]),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "pipeline",
            label: _vm.$t.__("common.labels.pipeline")
          }
        },
        [
          _c(
            "el-select",
            {
              ref: "pipeline",
              staticClass: "wp-10",
              attrs: {
                placeholder: _vm.$t.__(
                  "thirds.thirdscomponents.FormFieldsOpportunity.select_pipeline"
                ),
                "data-bot": "opp-overview__main--pipeline"
              },
              model: {
                value: _vm.pipeline,
                callback: function($$v) {
                  _vm.pipeline = $$v
                },
                expression: "pipeline"
              }
            },
            _vm._l(_vm.listings.pipelineList, function(option) {
              return _c("el-option", {
                key: option.value,
                ref: "pipeline",
                refInFor: true,
                attrs: {
                  "data-bot": "opp-overview__main--pipeline-list",
                  value: option,
                  label: option.label
                }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasPipeline
        ? _c(
            "el-form-item",
            { attrs: { prop: "step", label: _vm.$t.__("common.labels.step") } },
            [
              _c(
                "el-select",
                {
                  ref: "step",
                  staticClass: "wp-10",
                  attrs: {
                    placeholder: _vm.$t.__(
                      "thirds.thirdscomponents.FormFieldsOpportunity.select_step"
                    ),
                    "data-bot": "opp-overview__main--step"
                  },
                  model: {
                    value: _vm.step,
                    callback: function($$v) {
                      _vm.step = $$v
                    },
                    expression: "step"
                  }
                },
                _vm._l(_vm.listings.stepList, function(option) {
                  return _c("el-option", {
                    key: option.value,
                    attrs: {
                      "data-bot": "opp-overview__main--step-list",
                      value: option,
                      label: option.label
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          staticClass: "prelative wp-5",
          attrs: {
            prop: "percentage",
            label: _vm.$t.__("common.labels.probability")
          }
        },
        [
          _c("el-input", {
            ref: "percentage",
            staticClass: "aleft",
            attrs: {
              type: "number",
              "data-bot": "opp-overview__main--percentage"
            },
            model: {
              value: _vm.percentage,
              callback: function($$v) {
                _vm.percentage = $$v
              },
              expression: "percentage"
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass:
                "fc-unselectable pabsolute fs-5 el-input-icons__percentage"
            },
            [_vm._v("%")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }